<template>
  <v-layout :class="{'pt-0' : $vuetify.breakpoint.xsOnly, 'pt-5 mt-5' : !$vuetify.breakpoint.xsOnly}">
    <v-flex xs12 sm11 offset-sm1 v-if="!loading">
      <v-layout row v-if="error">
        <v-flex xs12>
          <app-alert @dismissed="onDismissed" :text="error.message" :color="error.colour"></app-alert>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12>
          <div class="app-panel white py-4" :class="{'px-4' : $vuetify.breakpoint.xsOnly, 'px-5' : !$vuetify.breakpoint.xsOnly}">
            <form @submit.prevent="openReAuth('saveEmail', 'Enter your current password to change your email address.')">
              <v-layout row wrap pb-3>
                <v-flex xs12>
                  <span class="subheading">Your email</span>
                </v-flex>
              </v-layout>
                <v-layout align-end row fill-height wrap>
                  <v-flex xs12 md8>
                     <v-text-field
                      name="email"
                      label="Mail"
                      id="email"
                      v-model="email"
                      type="email"
                      required></v-text-field>
                  </v-flex>
                  <v-flex xs12 md3 offset-md1 pt-3 pb-3>
                    <v-btn block depressed color="primary" type="submit" :disabled="loading" :loading="loading">
                      Save Email
                      <span slot="loader" class="custom-loader">
                        <v-icon light>cached</v-icon>
                      </span>
                    </v-btn>
                  </v-flex>
                </v-layout>
                </form>
          </div>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 mt-4>
          <div class="app-panel white py-4" :class="{'px-4' : $vuetify.breakpoint.xsOnly, 'px-5' : !$vuetify.breakpoint.xsOnly}">
            <form @submit.prevent="openReAuth('savePassword', 'Enter your current password to save your new password.')">
              <v-layout row wrap pb-3>
                <v-flex xs12>
                  <span class="subheading">Change your password</span>
                </v-flex>
              </v-layout>
                <v-layout align-end row fill-height wrap>
                  <v-flex xs12 md8>
                      <v-text-field
                      name="password"
                      label="Password"
                      id="password"
                      v-model="password"
                      type="password"
                      required></v-text-field>
                  </v-flex>
                  <v-flex xs12 md3 offset-md1 pt-3 pb-3>
                    <v-btn block depressed color="primary" type="submit" :disabled="loading" :loading="loading">
                      Save Password
                      <span slot="loader" class="custom-loader">
                        <v-icon light>cached</v-icon>
                      </span>
                    </v-btn>
                  </v-flex>
                </v-layout>
                </form>
          </div>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 mt-4 >
          <div class="app-panel white py-4" :class="{'px-4' : $vuetify.breakpoint.xsOnly, 'px-5' : !$vuetify.breakpoint.xsOnly}">
            <form @submit.prevent="openReAuth('deleteAccount', 'Your account is pre-paid up until ' + formatDate(group.subscription.current_period_end) + '. If you delete your account now we can\'t reinstate it or issue a refund.')">
              <v-layout row wrap pb-3>
                <v-flex xs12>
                  <span class="subheading">Delete account</span>
                </v-flex>
              </v-layout>
              <v-layout align-end row fill-height wrap>
                <v-flex xs12 md8>
                  <p>Once you delete your account, there is no going back. Please be certain.</p>
                </v-flex>
                <v-flex xs12 md3 offset-md1 pt-3 pb-3>
                  <v-btn block depressed color="error" type="submit" :disabled="loading" :loading="loading">
                    Delete account
                    <span slot="loader" class="custom-loader">
                      <v-icon light>cached</v-icon>
                    </span>
                  </v-btn>
                </v-flex>
              </v-layout>
            </form>
          </div>
        </v-flex>
      </v-layout>
    </v-flex>
    <reauthenticate
    @closeReAuth='closeReAuth'
    :showReAuthDialog='showReAuthDialog'
    @deleteAccount='onDeleteAccount'
    @saveEmail='onSaveEmail'
    @savePassword='onSavePassword'
    :callback='callback'
    :dialogMessage='dialogMessage'></reauthenticate>
  </v-layout>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/functions'

import { formatDate } from '@/components/Mixins/formatDate'
import Reauthenticate from '@/components/Shared/Reauthenticate'
export default {
  components: {
    Reauthenticate
  },
  mixins: [formatDate],
  data () {
    return {
      user: this.$store.getters.user,
      complete: false,
      email: this.$store.getters.user.email,
      password: '',
      dialogMessage: '',
      callback: '',
      showReAuthDialog: false,
      groupId: this.$store.getters.user.group

    }
  },
  computed: {
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    },
    group () {
      return this.$store.getters.group
    }
  },
  methods: {
    onSaveEmail () {
      // Vuex
      if (this.email === '') {
        this.$store.dispatch('setError', { message: 'Please enter an email address' })
      }
      this.$store.dispatch('updateEmail', this.email)
    },
    onSavePassword () {
      // Vuex
      if (this.password === '') {
        this.$store.dispatch('setError', { message: 'Please enter a 6 digit password' })
      }
      this.$store.dispatch('updatePassword', this.password)
    },
    openReAuth (callback, dialogMessage) {
      this.callback = callback
      this.dialogMessage = dialogMessage
      this.showReAuthDialog = true
    },
    closeReAuth () {
      this.showReAuthDialog = false
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    },
    async onDeleteAccount () {
      this.$store.commit('setLoading', true)
      // quick check again to ensure that delete is typed
      try {
        this.showDialog = false
        const groupId = this.groupId
        const userId = this.user.id
        const stripeId = this.group.stripeId
        const fbuser = firebase.auth().currentUser
        // remove the listeners
        firebase.database().ref(`clients/${groupId}`).off()
        firebase.database().ref(`bank-transactions-matches/${groupId}`).off()
        // now delete the user
        await fbuser.delete()
        // the delete callable
        const deleteUser = firebase.functions().httpsCallable('deleteUser')
        // call it with the group and selected Stripe plan identifier,
        await deleteUser({ stripeId: stripeId, groupId: groupId, userId: userId })
        // remove any plaid accounts
        const removePlaid = firebase.functions().httpsCallable('removePlaid')
        await removePlaid({ groupId: groupId })
        this.$store.commit('setError', false)
        this.$store.dispatch('logout')
        // now go to logout
      } catch (error) {
        this.$store.commit('setError', error.message)
        this.$store.commit('setLoading', false)
      }
    }
  }
}
</script>
